/**
 * Created by xinjundong on 2017/11/20.
 */
export const get = function (selector) {
  return document.querySelector(selector)
}
export const gets = function (selector) {
  return document.querySelectorAll(selector)
}



// WEBPACK FOOTER //
// ./src/api/utils/dom.js